import { defineStore } from 'pinia';
import api from '@/api/api';
import type { ZEvent } from '@schemas/event.schemas';

export const useEventsStore = defineStore('events', {
    state: () => ({
        events: [] as ZEvent[],
        myEvents: undefined as ZEvent[] | undefined,
        currentEvent: null as ZEvent | null
    }),
    getters: {
        // need for provider when for example request an announcer to select a specific event
        myAvailableEvents(state): ZEvent[] {
            if (state.myEvents === undefined) {
                return [];
            }
           return state.myEvents
                .filter(
                    (event) =>
                        event.isDraft !== true
                        // we also do not consider application.status as well
                        // && event.application?.status === 'open'
                        // we do not consider deadline if a provider wants to request he should be able to
                        // && (event.isOnboardingEvent || new Date(event?.application?.deadline) > new Date())
                )
                .sort((a, b) => a.title.localeCompare(b.title));
        }
    },
    actions: {
        clearMyData() {
            this.myEvents = [];
            this.currentEvent = null;
        },
        async fetchEvent(eventId: string): Promise<ZEvent> {
            log.debug(`fetchEvent(${eventId})`);
            this.currentEvent = this.events.find(app => app._id === eventId) ||
                this.myEvents?.find(app => app._id === eventId) ||
                await api.getDocument<ZEvent>('events', eventId);
            return this.currentEvent;
        },
        async fetchEvents(query: Record<string, any> = {}): Promise<ZEvent[]> {
            this.events = await api.getDocuments<ZEvent>('events', query);
            return this.events;
        },
        async fetchMyEvents(query: Record<string, any> = {}): Promise<ZEvent[]> {
            if(this.myEvents === undefined) {
                const results = await api.getDocuments<ZEvent>('events/my', query);
                this.myEvents = results || [];
            }
            return this.myEvents;
        },
        async addEvent(event: ZEvent): Promise<ZEvent> {
            const newEvent = await api.postDocument<ZEvent>('events', event);
            this.events.push(newEvent);
            if (this.myEvents === undefined) {
                this.myEvents = [];
            }
            this.myEvents.push(newEvent);
            this.currentEvent = newEvent;
            return newEvent;
        },
        async updateEvent(event: ZEvent): Promise<ZEvent> {
            const updatedEvent = await api.putDocument<ZEvent>('events', event);
            this.events = this.events.map(event => event._id === updatedEvent._id ? updatedEvent : event);
            this.myEvents = this.events.map(event => event._id === updatedEvent._id ? updatedEvent : event);
            this.currentEvent = this.currentEvent?._id === updatedEvent._id ? updatedEvent : this.currentEvent;
            return updatedEvent;
        },
        async deleteEvent(eventId: string): Promise<void> {
            await api.deleteDocument<ZEvent>('events', eventId);
            this.events = this.events.filter(event => event._id !== eventId);
        }
    }
});
